import { useState } from 'react'
import { v4 } from 'uuid'

export function useUniqueId() {
  const [uniqueId] = useState(v4)
  return uniqueId
}
